import { useRouter } from 'next/router'
import { FeedSortInput as Component } from 'ui-components'
import { getSearchQuery } from 'utils'
import { useSort } from '~map-search/hooks/useSort'

const FeedSortInput = () => {
  const router = useRouter()
  const value = useSort()

  const handleChange = (_, value) => {
    router.push(getSearchQuery({ sort: value }))

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    })
  }

  return (
    <Component
      value={value}
      onChange={handleChange}
    />
  )
}

export { FeedSortInput }
